import React from 'react'
import { Box, Checkbox, FormControlLabel } from '@mui/material'
import { updateQntmReminder } from 'src/State/Shop/ShopAction'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useDispatch } from 'react-redux'

/** This component updates the Quantom Reminder on local storage */
const QntmReminder: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()

  const handleCheckedReminder = (checked: boolean): void => {
    dispatch(updateQntmReminder(!checked))
  }

  return (
    <Box>
      <FormControlLabel control={<Checkbox onChange={e => handleCheckedReminder(e.target.checked)} />} label={t('shop.common.dont-show-again')} />
    </Box>
  )
}

export default QntmReminder
